import type { HomeLayoutMode } from "@/types/userPreferences.ts";

/**
 * What the thread list's layout switch is called, in both apps.
 *
 * Here rather than inline, for the reason `filterLabels` in `threadFilters` is:
 * each app only ever reads its own string, so two copies can word the same
 * control differently and nothing fails.
 *
 * Keyed by the mode the control switches *to*, so the label names the layout
 * you would move to rather than the one you are in.
 */
export const layoutSwitchLabels: Record<HomeLayoutMode, string> = {
  compact: "Switch to compact",
  large: "Switch to cards",
};
